import { useEffect, useState } from "react";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import logo from "../../assets/senca/logo.jpg";
import landingStyles from "../Landing/Landing.module.css";
import { socialLinks } from "../Landing/landingContent";
import styles from "./ProjectDetail.module.css";
import { getProjectBySlug } from "./projectsData";

export default function ProjectDetail() {
  const { slug: slugParam } = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);
  const slug = slugParam || location.pathname.replace(/^\//, "");
  const project = getProjectBySlug(slug);
  const [currentSlide, setCurrentSlide] = useState(0);

  useEffect(() => {
    if (!project?.gallery?.length) return undefined;

    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % project.gallery.length);
    }, 5000);

    return () => clearInterval(timer);
  }, [project]);

  const handleNavClick = (sectionId) => {
    setMenuOpen(false);
    navigate(`/#${sectionId}`);
  };

  if (!project) {
    return (
      <div className={landingStyles.page}>
        <div className={styles.notFound}>
          <h1>Projeto não encontrado</h1>
          <button type="button" onClick={() => navigate("/")}>
            Voltar ao site
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className={landingStyles.page}>
      <header className={landingStyles.header}>
        <div className={landingStyles.headerInner}>
          <button
            type="button"
            className={landingStyles.menuToggle}
            aria-label="Abrir menu"
            onClick={() => setMenuOpen((open) => !open)}
          >
            ☰
          </button>

          <img
            src={logo}
            alt="Senca Serviços e Engenharia"
            className={landingStyles.logo}
            onClick={() => navigate("/")}
          />

          <nav
            className={`${landingStyles.nav} ${menuOpen ? landingStyles.navOpen : ""}`}
          >
            <button
              type="button"
              className={landingStyles.navLink}
              onClick={() => handleNavClick("projetos")}
            >
              Projetos
            </button>
            <button
              type="button"
              className={landingStyles.navLink}
              onClick={() => handleNavClick("sobre")}
            >
              Sobre
            </button>
            <button
              type="button"
              className={landingStyles.navLink}
              onClick={() => handleNavClick("atuacao")}
            >
              Atuação
            </button>
            <button
              type="button"
              className={landingStyles.navLink}
              onClick={() => handleNavClick("contato")}
            >
              Contato
            </button>
          </nav>
        </div>
      </header>

      <button
        type="button"
        className={landingStyles.systemAccess}
        onClick={() => navigate("/login")}
        title="Acesso ao Sistema"
      >
        Acesso ao Sistema
      </button>

      <main className={styles.content}>
        <section className={styles.carousel} aria-label="Galeria do projeto">
          <div
            className={styles.carouselTrack}
            style={{ transform: `translateX(-${currentSlide * 100}%)` }}
          >
            {project.gallery.map((image, index) => (
              <div key={image} className={styles.carouselSlide}>
                <img
                  src={image}
                  alt={`${project.title} - foto ${index + 1}`}
                  className={styles.carouselImage}
                />
              </div>
            ))}
          </div>

          <div className={styles.carouselOverlay}>
            <p className={styles.carouselLabel}>Projeto</p>
            <h1 className={styles.carouselTitle}>{project.title}</h1>
          </div>

          <div className={styles.carouselDots}>
            {project.gallery.map((image, index) => (
              <button
                key={image}
                type="button"
                className={`${styles.carouselDot} ${
                  index === currentSlide ? styles.carouselDotActive : ""
                }`}
                aria-label={`Ir para foto ${index + 1}`}
                onClick={() => setCurrentSlide(index)}
              />
            ))}
          </div>
        </section>

        <section className={styles.detailsGrid}>
          <div className={styles.detailsText}>
            <h2 className={styles.title}>{project.title}</h2>
            <p className={styles.detailLine}>Inicio: {project.startDate}</p>
            <p className={styles.detailLine}>Termino: {project.endDate}</p>
            <p className={styles.detailLine}>Local: {project.location}</p>
            <p className={styles.detailLine}>{project.description}</p>
          </div>

          <div className={styles.detailsImages}>
            {project.gallery.slice(1).map((image, index) => (
              <div key={image} className={styles.sideImageWrap}>
                <img
                  src={image}
                  alt={`${project.title} - imagem ${index + 2}`}
                  className={styles.sideImage}
                />
              </div>
            ))}
          </div>
        </section>
      </main>

      <footer className={styles.pageFooter}>
        <div className={styles.pageFooterInner}>
          <p className={styles.pageFooterText}>
            2024 - SENCA Serviços e Engenharia - Powered by PepperMedia Digital
          </p>
          <div className={styles.pageFooterSocial}>
            {socialLinks.map((link) => (
              <a
                key={link.name}
                href={link.href}
                target="_blank"
                rel="noreferrer"
                aria-label={link.name}
              >
                <img src={link.icon} alt={link.name} />
              </a>
            ))}
          </div>
        </div>
      </footer>
    </div>
  );
}
